<template>
  <div class="flex w-full">
    <div class="flex items-center mr-6">
      <img src="@/images/instagram.svg" class="w-8">
    </div>
    <input class="h-10 p-2 shadow-md font-sans-serif w-full md:w-auto" placeholder="Instagram Link"
      v-model="instagramUrl"
      @change="updateSocial"/>
  </div>
</template>
<script>
import axios from 'axios';
import { mapGetters } from 'vuex';

export default {
  data() {
    return {
      instagramUrl: '',
    };
  },

  computed: {
    ...mapGetters({
      user: 'auth/user',
    }),
  },

  mounted() {
    this.instagramUrl = this.user.instagram ? this.user.instagram : '';
  },

  methods: {
    updateSocial() {
      axios.put(`/api/users/${this.user.id}`, { instagram: this.instagramUrl });
    },
  },

};
</script>
